(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDetailController', StatementTypeDetailController);

    StatementTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'StatementType'];

    function StatementTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:statementTypeUpdate', function(event, result) {
            vm.statementType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
